import { render, staticRenderFns } from "./SupplierContactsBox.vue?vue&type=template&id=4f0fa578&scoped=true&"
import script from "./SupplierContactsBox.vue?vue&type=script&lang=js&"
export * from "./SupplierContactsBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0fa578",
  null
  
)

export default component.exports